export const passwordRulesSatisfied = function (password) {
  return hasLength(password) &&
      containsUppercaseCharacter(password) &&
      containsLowercaseCharacter(password) &&
      containsNumber(password) &&
      containsValidSpecialCharacter(password)
}

export const hasLength = function (password) {
  return password.length >= 10 && password.length <= 256
}

export const containsUppercaseCharacter = function (password) {
  return /[A-Z]/.test(password)
}

export const containsLowercaseCharacter = function (password) {
  return /[a-z]/.test(password)
}

export const containsNumber = function (password) {
  return /[0-9]/.test(password)
}

export const containsValidSpecialCharacter = function (password) {
  return /[!"#$%&' ()*+,./;:=?_@>-]/.test(password)
}

export const containsInvalidCharacter = function (password) {
  return /[^a-zA-Z0-9!"#$%&' ()*+,./;:=?_@>-]/.test(password)
}

export const validSpecialCharactersString = function () {
  return "!\"#$%&' ()*+,./;:=?_@>-"
}

export const hasMobileLength = function (mobile) {
  return mobile.length >= 7 && mobile.length <= 40
}

export const validateMobileNumber = function (mobile) {
  return hasMobileLength(mobile) && hasMobilePattern(mobile)
}

export const hasMobilePattern = function (mobile) {
  return new RegExp('^(\\+|00)[(),.\\s\\d-/]+$').exec(mobile) !== null
}

export const isMobileCountryCodeBlacklisted = function (mobile) {
  const blackListedCountryCodes = ['+99', '+7', '+380', '+212']

  // Construct the regular expression pattern using the array of black listed country codes
  const blackListedCountryCodesPattern = new RegExp(
    `^(?:${blackListedCountryCodes.map(code => '\\' + code).join('|')})[(),.\\s\\d-/]+$`
  )

  return new RegExp(blackListedCountryCodesPattern).exec(mobile) !== null
}

export const emailContainsInvalidCharacter = function (email) {
  return /[*&%/<> ]/.test(email)
}

export const nameContainsInvalidCharacter = function (name) {
  return /[\\/<>@;%{}=#"[\]?$|\\.]/.test(name)
}

export const fieldIsValid = function (value, regex) {
  if (regex != null) {
    return new RegExp(regex).test(value)
  } else {
    return true
  }
}

export const fieldContainsInvalidCharacter = function (value, regex) {
  if (regex != null) {
    return new RegExp(regex).test(value)
  } else {
    return false
  }
}

export const validateEmail = function (email) {
  return !emailContainsInvalidCharacter(email) && validateEmailPattern(email)
}

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validateEmailPattern = function (email) {
  return EMAIL_REGEX.test(String(email).toLowerCase())
}

export const hasName = function (password, name) {
  const updatedPassword = password.toLowerCase()
  const updatedName = name.toLowerCase().replaceAll(/\s/g, '')
  if (updatedName.length <= 3) {
    return false
  }
  if (updatedName && updatedName.indexOf('@') !== -1) {
    const splitArray = updatedName.split('@')
    return updatedPassword.includes(splitArray[0]) || updatedPassword.includes(splitArray[1])
  }
  const copyName = name.replace(/\D/g, '').slice(-10)
  return (updatedName && updatedPassword.includes(updatedName)) || (copyName && updatedPassword.includes(copyName))
}

export const repetitiveAndSequenceCheck = function (password) {
  const pwdChar = password.split('')
  for (let i = 0; i < pwdChar.length - 2; ++i) {
    if (parseInt(pwdChar[i]) + 1 === parseInt(pwdChar[i + 1]) && parseInt(pwdChar[i]) + 2 === parseInt(pwdChar[i + 2])) {
      return true
    }
    const ascii1 = pwdChar[i].toLowerCase()
    const ascii2 = pwdChar[i + 1].toLowerCase()
    const ascii3 = pwdChar[i + 2].toLowerCase()
    if (ascii1 === ascii2 && ascii2 === ascii3) {
      return true
    }
    const code1 = password.toLowerCase().charCodeAt(i)
    const code2 = password.toLowerCase().charCodeAt(i + 1)
    const code3 = password.toLowerCase().charCodeAt(i + 2)
    if (code1 + 1 === code2 && code2 + 1 === code3) {
      return true
    }
  }
  return false
}
